var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-project"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "project",
    clipPath: "url(#clip-project)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(-43.751 -666.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(46.75 666.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_228",
    "data-name": "Path 228",
    transform: "translate(-46.75 -666.7)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.93,666.7H51.75a5,5,0,0,0-5,5v30a5,5,0,0,0,5,5H75.032a5.066,5.066,0,0,0,5.051-5.051v-21.8a3.589,3.589,0,0,0-1.051-2.538l-9.564-9.565A3.59,3.59,0,0,0,66.93,666.7Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51.75 669.199951171875 C 50.37149810791016 669.199951171875 49.25 670.321533203125 49.25 671.7000732421875 L 49.25 701.7000732421875 C 49.25 703.0784912109375 50.37149810791016 704.199951171875 51.75 704.199951171875 L 75.0322265625 704.199951171875 C 75.70793151855469 704.199951171875 76.34701538085938 703.9330444335938 76.83172607421875 703.4483032226562 C 77.31640625 702.9636840820312 77.58333587646484 702.3246459960938 77.58333587646484 701.6490478515625 L 77.58333587646484 679.853515625 C 77.58333587646484 679.5667114257812 77.46715545654297 679.2861328125 77.26443481445312 679.0834350585938 L 67.70014953613281 669.5188598632812 C 67.49742126464844 669.3162231445312 67.21672058105469 669.199951171875 66.93000030517578 669.199951171875 L 51.75 669.199951171875 M 51.75 666.699951171875 L 66.93000030517578 666.699951171875 C 67.88111877441406 666.699951171875 68.79444885253906 667.0777587890625 69.4677734375 667.7509765625 L 79.0322265625 677.315673828125 C 79.70555114746094 677.9888916015625 80.08333587646484 678.90234375 80.08333587646484 679.853515625 L 80.08333587646484 701.6490478515625 C 80.08333587646484 704.4267578125 77.80999755859375 706.699951171875 75.0322265625 706.699951171875 L 51.75 706.699951171875 C 48.98779296875 706.699951171875 46.75 704.462158203125 46.75 701.7000732421875 L 46.75 671.7000732421875 C 46.75 668.937744140625 48.98779296875 666.699951171875 51.75 666.699951171875 Z",
    stroke: "none",
    fill: "#5c6d7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(7.43 22.287)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 17.593,
    height: 3.519,
    rx: 1.759,
    transform: "translate(0 0)",
    fill: "#5c6d7e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.e35a7424cf706254a1fb76c7b471cf26.svg";
export { ForwardRef as ReactComponent };